module.exports = __webpack_public_path__ + "img/vertical.0af08681.png";